import { render, staticRenderFns } from "./PedidoAddItemNovo.vue?vue&type=template&id=68c3a97c"
import script from "./PedidoAddItemNovo.vue?vue&type=script&lang=js"
export * from "./PedidoAddItemNovo.vue?vue&type=script&lang=js"
import style0 from "./PedidoAddItemNovo.vue?vue&type=style&index=0&id=68c3a97c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports